export const ContractDecisionEN = {
    "decisionContract": {
        "heading": {
            "detail": "Termination of labor contract dicision",
                "info": "General Information",
                "reason": "Create new reason",
                "add": "Create new decision contract",
                "update": "Update decision contract"
        },
        "label": {
            "no": "Decision No",
                "decisionDate": "Decision date",
                "decisionMaker": "Decision maker",
                "validityDate": "Validity date",
                "employee": "Employee",
                "reason": "Reason",
                "description": "Description",
                "status": "Status"
        },
        "placeholder": {
            "no": "Enter Decision No",
                "decisionDate": "Enter Decision date",
                "decisionMaker": "Enter Decision maker",
                "validityDate": "Enter Validity date",
                "employee": "Enter Employee",
                "reason": "Enter Reason",
                "description": "Enter Description"
        },
        "message": {
            "add": "Add Success",
                "update": "Update Success"
        },
        "values": {
            "status": {
                "pending": "PENDING",
                    "approved": "APPROVED"
            },
            "reason": {
                "active": "Active",
                    "inactive": "Inactive"
            }
        }
    }
}